import { startOfTomorrow } from 'date-fns/startOfTomorrow';
import { getZonedDate } from '@eika-infrastruktur/date';
const tomorrow = getZonedDate(startOfTomorrow());
export const recurringPaymentInitialState = {
    toAccount: undefined,
    fromAccount: undefined,
    amount: undefined,
    note: '',
    firstBankingDate: tomorrow,
    firstPaymentDate: tomorrow,
    lastPaymentDate: undefined,
    paymentInterval: 'MONTHLY',
    showFromAccounts: false,
    showToAccounts: false,
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3RhdGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvY29tcG9uZW50cy90cmFuc2FjdGlvbi9SZWN1cnJpbmdQYXltZW50L2Zvcm0vc3RhdGUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLGVBQWUsRUFBRSxNQUFNLDBCQUEwQixDQUFDO0FBRTNELE9BQU8sRUFBRSxZQUFZLEVBQWEsTUFBTSwwQkFBMEIsQ0FBQztBQW1CbkUsTUFBTSxRQUFRLEdBQUcsWUFBWSxDQUFDLGVBQWUsRUFBRSxDQUFDLENBQUM7QUFFakQsTUFBTSxDQUFDLE1BQU0sNEJBQTRCLEdBQTBCO0lBQy9ELFNBQVMsRUFBRSxTQUFTO0lBQ3BCLFdBQVcsRUFBRSxTQUFTO0lBQ3RCLE1BQU0sRUFBRSxTQUFTO0lBQ2pCLElBQUksRUFBRSxFQUFFO0lBQ1IsZ0JBQWdCLEVBQUUsUUFBUTtJQUMxQixnQkFBZ0IsRUFBRSxRQUFRO0lBQzFCLGVBQWUsRUFBRSxTQUFTO0lBQzFCLGVBQWUsRUFBRSxTQUFTO0lBQzFCLGdCQUFnQixFQUFFLEtBQUs7SUFDdkIsY0FBYyxFQUFFLEtBQUs7Q0FDeEIsQ0FBQyJ9